<template>
  <div class="journey">
    <div class="journey__inner">
      <p class="text-black-90 text-center fw-extrabold">
        For ADHD in patients aged 6&nbsp;years and older to increase attention and decrease impulsiveness and hyperactivity.
      </p>

      <h2 class="journey__heading text-center">
        What could it mean to wake up ready to shine with JORNAY PM?
      </h2>

      <div class="journey__list">
        <div
          v-for="(item, itemIndex) in items"
          :key="itemIndex"
          class="journey__item"
        >
          <div class="journey__image">
            <img :alt="item.alt" :src="item.image" />
          </div>
          <p
            class="journey__caption text-black text-center"
            v-html="item.caption"
          ></p>
        </div>
      </div>
      <p
        class="fw-extrabold main-text text-center simple-text-home simple-text-home--1"
      >
        Clinical studies showed all-day symptom control upon awakening, into the
        late afternoon and early evening.<br>
        <span class="footnote-line d-block">
          *In clinical studies, children and adolescents were not given an afternoon booster.
        </span>
      </p>

      <p class="fw-extrabold main-text text-center simple-text-home">
        Talk to your healthcare provider about JORNAY PM to learn if it may be right for you or your&nbsp;child.
      </p>

    </div>
  </div>
</template>

<script>
export default {
  name: "Journey",
  data() {
    return {
      items: [
        {
          image: require("../../assets/images/3_25/home/NightDosing.svg"),
          caption: "Taken at night to <br>tackle tomorrow",
          alt: "Blue graphic of a crescent moon",
        },
        {
          image: require("../../assets/images/3_25/home/UponWaking.svg"),
          caption:
            'Already managing <br class="d-none d-md-block">ADHD symptoms <br class="d-none d-md-block">upon waking',
          alt: "Yellow graphic of a sun",
        },
        {
          image: require("../../assets/images/3_25/home/Steady.svg"),
          caption:
            'Smooth, steady coverage <br class="d-none d-md-block">for the day ahead without a <br class="d-none d-md-block">short-acting booster*',
          alt: "Orange graphic of a scale",
        },
        {
          image: require("../../assets/images/3_25/home/ShortActingBooster.svg"),
          caption:
            'Proven ADHD symptom <br class="d-none d-md-block">support from morning<br class="d-none d-md-block"> through the afternoon<br class="d-none d-md-block"> into the early evening',
          alt: "Blue graphic of a clock",
        },
      ],
    };
  },
};
</script>

<style scoped>
.footnote-line {
  display: block;
  margin-top: 4px;
}

@media (min-width: 1200px) {
  .journey__inner {
    max-width: 1207px;
  }

  .journey__item {
    width: 25%;
    max-width: 337px;
  }

  .journey__list {
    margin-bottom: 35px;
  }
}
</style>
